'use strict';

function createStyles(styles) {
  return styles;
}

module.exports = createStyles;
